module.exports = __webpack_public_path__ + "img/zoo.cc5aa208.svg";